<template>
  <b-card no-body>
    <b-card-body>
      <b-row>
        <b-col>
          <b-input-group>
            <b-form-input
              v-model="search"
              placeholder="Ürün Ara"
            />
            <b-input-group-append>
              <b-button
                v-if="search !== ''"
                variant="warning"
                @click="resetSearch"
              ><FeatherIcon icon="XIcon" /></b-button>
              <b-button
                variant="primary"
                :disabled="search === ''"
                @click="searchData"
              ><FeatherIcon icon="SearchIcon" /></b-button>
            </b-input-group-append>
          </b-input-group>
        </b-col>
        <b-col
          cols="12"
          md="auto"
        >
          <b-button
            to="products/add"
            variant="primary"
            block
          ><FeatherIcon icon="PlusIcon" />
            Ekle</b-button>
        </b-col>
      </b-row>
    </b-card-body>
    <b-table
      responsive="sm"
      :fields="fields"
      :items="dataList"
      striped
    >
      <template #cell(pcode)="data">
        {{ data.item.pcode }}
      </template>
      <template #cell(title)="data">
        <div>{{ data.item.title }}</div>
      </template>
      <template #cell(brand)="data">
        {{ data.item.brand }}
      </template>
      <template #cell(product_type)="data">
        {{ data.item.product_type }}
      </template>
      <template #cell(list_price)="data">
        <div class="text-right">
          <span v-if="data.item.list_price > 0">
            {{ priceFormater(data.item.list_price) }} {{ data.item.currency_symbol }}
          </span>
          <span v-else>-</span>
        </div>
      </template>
      <template #cell(labor_price)="data">
        <div class="text-right">
          <span v-if="data.item.labor_price > 0">
            {{ priceFormater(data.item.labor_price) }} {{ data.item.currency_symbol }}
          </span>
          <span v-else>-</span>
        </div>
      </template>
      <template #cell(control)="data">
        <b-button
          :to="'/products/edit/' + data.item.id"
          variant="outline-primary"
          size="sm"
        >
          Güncelle
        </b-button>
      </template>
    </b-table>
    <b-card-footer>
      <b-pagination
        v-model="currentPage"
        :total-rows="dataCount"
        :per-page="perPage"
        first-number
        last-number
        prev-class="prev-item"
        next-class="next-item"
      >
        <template #prev-text>
          <feather-icon
            icon="ChevronLeftIcon"
            size="18"
          />
        </template>
        <template #next-text>
          <feather-icon
            icon="ChevronRightIcon"
            size="18"
          />
        </template>
      </b-pagination>
    </b-card-footer>
  </b-card>
</template>

<script>
import {
  BCard, BCardBody, BRow, BCol, BTable, BCardFooter, BPagination, BButton, BFormInput, BInputGroup, BInputGroupAppend,
} from 'bootstrap-vue'

export default {
  name: 'Index',
  components: {
    BCard,
    BCardBody,
    BTable,
    BRow,
    BCol,
    BCardFooter,
    BPagination,
    BButton,
    BFormInput,
    BInputGroup,
    BInputGroupAppend,
  },
  data() {
    return {
      currentPage: 1,
      perPage: 25,
      search: '',
      fields: [
        {
          key: 'pcode',
          label: 'ÜRÜN KODU',
          thStyle: { width: '140px', textAlign: 'left', verticalAlign: 'middle' },
        },
        {
          key: 'title',
          label: 'ÜRÜN ADI',
        },
        {
          key: 'brand',
          label: 'MARKA',
          thStyle: { width: '140px', textAlign: 'left', verticalAlign: 'middle' },
        },
        {
          key: 'product_type',
          label: 'ÜRÜN GRUBU',
          thStyle: { width: '160px', textAlign: 'left', verticalAlign: 'middle' },
        },
        {
          key: 'list_price',
          label: 'LİSTE FİYATI',
          thStyle: { width: '160px', textAlign: 'right', verticalAlign: 'middle' },
        },
        {
          key: 'labor_price',
          label: 'İŞÇİLİK',
          thStyle: { width: '160px', textAlign: 'right', verticalAlign: 'middle' },
        },
        {
          key: 'control',
          label: 'Kontrol',
        },
      ],
      dataQuery: {
        select: [
          'products.id AS id',
          'products.pcode AS pcode',
          'products.title AS title',
          'products.list_price AS list_price',
          'products.labor_price AS labor_price',
          'brands.title AS brand',
          'product_types.title AS product_type',
          'currencies.symbol AS currency_symbol',
        ],
        limit: 25,
        start: 0,
      },
    }
  },
  computed: {
    dataList() {
      return this.$store.getters['products/getProducts']
    },
    dataCount() {
      return this.$store.getters['products/getProductsCount']
    },
  },
  watch: {
    currentPage(val) {
      const page = (val - 1) * 25
      this.pagination(page)
    },
  },
  created() {
    this.getDataList()
  },
  methods: {
    searchData() {
      this.dataQuery.or_like = {
        'products.pcode': this.search,
        'products.title': this.search,
      }
      this.getDataList()
    },
    resetSearch() {
      this.dataQuery.or_like = {}
      this.search = ''
      this.getDataList()
    },
    pagination(page) {
      this.dataQuery.start = page
      if (this.dataQuery.start === page) {
        this.getDataList()
      }
    },
    getDataList() {
      this.$store.dispatch('products/productsList', this.dataQuery)
    },
    priceFormater(price) {
      return new Intl.NumberFormat('tr-TR').format(price)
    },
  },
}
</script>
